export var setStateData = function setStateData(initialState) {
  return function (state, action) {
    Object.keys(action.payload).forEach(function (key) {
      if (key in initialState) {
        state[key] = action.payload[key];
      }
    });
  };
};